import React from 'react';

export const AccordionRow = ({children}: React.PropsWithChildren) => {
    return <div className="content-row">{children}</div>
}